import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export const state = {
  form: {
    preViewImage: '',
    profileRawFile: null,
    profileFileInfo: null,
    invitationNo: '',
    invitationFile: null,
    invitationText: '',
    smileNo: '',
    userNo: '',
    category: '',
    hasSecond: false,
    type: '',
    firstName: '',
    secondName: '',
    hostName: '',
    eventDate: '',
    eventDateTime: '',
    firstRelation: [
      { relation: '부', name: '' },
      { relation: '모', name: '' }
    ],
    secondRelation: [
      { relation: '부', name: '' },
      { relation: '모', name: '' }
    ],
    address: '',
    buildingName: '',
    latitude: '',
    longitude: '',
    parkingNote: '',
    transportNote: '',
    firstAccounts: [
      {
        accountHolder: '',
        bank: '선택(은행)',
        accountNumber: ''
      }
    ],
    secondAccounts: [
      {
        accountHolder: '',
        bank: '선택(은행)',
        accountNumber: ''
      }
    ],
    galleryRawFiles: [], // 갤러리에서 새로 등록할 이미지들
    galleryFileList: [], // 기존 저장된 이미지들
    gallery: []
  },
  detail: {},
  nextId: null,
  list: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
